$(function() {
	$('.scroll-center').each(function() {
		var $container = $(this);
		
		$container.find('.scroll-item').on('click', function() {
			var $item = $(this);
			
			$item[0].scrollIntoView({
				behavior: 'smooth', 
				block: 'center'
			});
		});
	});
});